// extracted by mini-css-extract-plugin
export default {"policy":"PasswordPolicy_policy__VoTIN","valid":"PasswordPolicy_valid__WKZOu","invalid":"PasswordPolicy_invalid__-PBuV"};